// Mock data for the luxury wedding website
// All Unsplash images are optimized with WebP format and reduced quality for faster loading

export const contactInfo = {
  phones: ['8679333354', '8679333355', '9816154248'],
  email: 'events@prettyplanettravels.com',
  location: 'Dharamshala, Himachal Pradesh, India',
  social: {
    instagram: 'https://www.instagram.com/destinationweddings.events?igsh=ZmVvM2puamJxM2Zq',
    facebook: 'https://www.facebook.com/share/17jZ8kBBmn/'
  }
};

export const heroImages = {
  main: 'https://images.unsplash.com/photo-1612883809638-9314edb33efb?w=800&q=75&fm=webp&auto=format',
  secondary: 'https://images.unsplash.com/photo-1607047795460-9521dfad2269?w=800&q=75&fm=webp&auto=format'
};

export const services = [
  {
    id: 'destination-wedding',
    title: 'Destination Wedding Planning',
    description: 'Complete destination wedding planning in the breathtaking landscapes of Himachal Pradesh. From venue selection to guest management, we handle everything.',
    image: 'https://images.unsplash.com/photo-1727425383452-2be55354f06e?w=600&q=75&fm=webp&auto=format',
    features: ['Venue Selection', 'Guest Management', 'Logistics Coordination', 'Backup Planning']
  },
  {
    id: 'wedding-decor',
    title: 'Luxury Wedding Décor',
    description: 'Exquisite mandap décor, stage decoration, floral arrangements, theme-based décor, lighting, and complete aesthetic transformation.',
    image: 'https://images.unsplash.com/photo-1745573673583-a51f665ae48e?w=600&q=75&fm=webp&auto=format',
    features: ['Mandap Décor', 'Floral Arrangements', 'Stage Decoration', 'Theme Design']
  },
  {
    id: 'complete-celebration',
    title: 'Complete Wedding Celebration',
    description: 'End-to-end management of every ceremony from Welcome to Reception including Haldi, Mehndi, Sangeet, Cocktail Night, and Wedding Ceremony.',
    image: 'https://images.unsplash.com/photo-1587012521796-6359d3678f2a?w=600&q=75&fm=webp&auto=format',
    features: ['Welcome Ceremony', 'Haldi & Mehndi', 'Sangeet & Cocktail', 'Wedding & Reception']
  },
  {
    id: 'sound-entertainment',
    title: 'Sound & Entertainment',
    description: 'Professional entertainment with ONLY branded sound systems (JBL & RCF). DJ, live bands, singers, dhol, folk performances, and complete stage production.',
    image: 'https://images.unsplash.com/photo-1698602807831-81066d89ed41?w=600&q=75&fm=webp&auto=format',
    features: ['JBL & RCF Sound', 'Professional DJ', 'Live Entertainment', 'Stage Lighting']
  },
  {
    id: 'events',
    title: 'Corporate & Social Events',
    description: 'Professional event planning and execution for corporate events, social gatherings, and special occasions with luxury touches.',
    image: 'https://images.unsplash.com/photo-1712314947761-a8d718bd8c32?w=600&q=75&fm=webp&auto=format',
    features: ['Corporate Events', 'Social Gatherings', 'Custom Themes', 'Full Coordination']
  },
  {
    id: 'honeymoon',
    title: 'Luxury Honeymoon Packages',
    description: 'Romantic and customized honeymoon experiences. Beach escapes, mountain retreats, complete planning, and personalized itineraries.',
    image: 'https://images.unsplash.com/photo-1648538923547-074724ca7a18?w=600&q=75&fm=webp&auto=format',
    features: ['Beach Destinations', 'Mountain Retreats', 'Custom Itineraries', 'Hotel Coordination']
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: 'Mountain Paradise Wedding',
    category: 'Destination Wedding',
    location: 'Dharamshala, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1614526262182-f380a54162b9?w=600&q=75&fm=webp&auto=format',
    description: 'A breathtaking 3-day destination wedding against the backdrop of Dhauladhar mountains.'
  },
  {
    id: 2,
    title: 'Royal Palace Celebration',
    category: 'Wedding Décor',
    location: 'Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1605553426886-c0a99033fda0?w=600&q=75&fm=webp&auto=format',
    description: 'Luxury mandap décor with traditional red and gold theme, creating a royal ambiance.'
  },
  {
    id: 3,
    title: 'Elegant Lakeside Wedding',
    category: 'Complete Celebration',
    location: 'Himachal Pradesh',
    image: 'https://images.pexels.com/photos/12550187/pexels-photo-12550187.png?auto=compress&cs=tinysrgb&w=600',
    description: 'Complete 5-event wedding celebration from Haldi to Reception with flawless execution.'
  },
  {
    id: 4,
    title: 'Luxury Banquet Setup',
    category: 'Wedding Décor',
    location: 'Dharamshala',
    image: 'https://images.pexels.com/photos/35160792/pexels-photo-35160792.jpeg?auto=compress&cs=tinysrgb&w=600',
    description: 'Premium indoor wedding décor with crystal chandeliers and elegant floral arrangements.'
  },
  {
    id: 5,
    title: 'Sangeet Night Extravaganza',
    category: 'Entertainment',
    location: 'Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1724847664960-5060a1ae8259?w=600&q=75&fm=webp&auto=format',
    description: 'High-energy sangeet night with JBL sound systems, professional DJ, and live performances.'
  },
  {
    id: 6,
    title: 'Romantic Floral Setup',
    category: 'Wedding Décor',
    location: 'Dharamshala',
    image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=75&fm=webp&auto=format',
    description: 'Elegant table settings with luxury floral arrangements and ambient lighting.'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya & Rahul',
    event: 'Destination Wedding',
    rating: 5,
    text: 'Our dream wedding in Dharamshala was beyond perfect! The team handled everything from décor to entertainment flawlessly. The JBL sound system made our sangeet night unforgettable.',
    image: 'https://images.unsplash.com/photo-1719410876441-48357b53e6fd'
  },
  {
    id: 2,
    name: 'Anjali & Vikram',
    event: 'Complete Wedding Planning',
    rating: 5,
    text: 'Absolutely stress-free experience! They managed our entire 4-day celebration perfectly. The mandap décor was breathtaking, and the coordination was impeccable.',
    image: 'https://images.unsplash.com/photo-1614526262182-f380a54162b9'
  },
  {
    id: 3,
    name: 'Neha & Arjun',
    event: 'Honeymoon Package',
    rating: 5,
    text: 'Our honeymoon package was perfectly planned. Every detail was taken care of, from luxury hotels to personalized itineraries. Truly romantic and memorable!',
    image: 'https://images.unsplash.com/photo-1648538923547-074724ca7a18'
  }
];

export const weddingCelebrationEvents = [
  {
    id: 'welcome',
    title: 'Welcome Ceremony',
    description: 'A warm and grand welcome for your guests with traditional rituals and hospitality.',
    icon: 'Users'
  },
  {
    id: 'haldi',
    title: 'Haldi Ceremony',
    description: 'Vibrant and joyful Haldi celebration with beautiful yellow-themed décor and arrangements.',
    icon: 'Sparkles'
  },
  {
    id: 'mehndi',
    title: 'Mehndi Ceremony',
    description: 'Elegant Mehndi setup with live artists, colorful décor, and complete guest entertainment.',
    icon: 'Palmtree'
  },
  {
    id: 'sangeet',
    title: 'Sangeet & Cocktail Night',
    description: 'High-energy night with professional DJ, JBL sound systems, live performances, and stage lighting.',
    icon: 'Music'
  },
  {
    id: 'wedding',
    title: 'Wedding Ceremony',
    description: 'The main ceremony with exquisite mandap décor, floral arrangements, and perfect orchestration.',
    icon: 'Heart'
  },
  {
    id: 'reception',
    title: 'Reception',
    description: 'Grand reception with luxury décor, entertainment, dining, and memorable celebrations.',
    icon: 'Crown'
  }
];

export const honeymoonPackages = [
  {
    id: 'beach-luxury',
    title: 'Luxury Beach Escape',
    description: 'Romantic beach destinations with luxury resorts, private dinners, and water activities.',
    image: 'https://images.unsplash.com/photo-1729707691048-722c1acf5c51',
    duration: '5-7 Days',
    destinations: ['Maldives', 'Goa', 'Andaman'],
    includes: ['5-Star Resort', 'Candlelight Dinner', 'Spa & Wellness', 'Water Sports']
  },
  {
    id: 'mountain-retreat',
    title: 'Mountain Retreat',
    description: 'Serene mountain destinations perfect for couples seeking tranquility and adventure.',
    image: 'https://images.pexels.com/photos/35144341/pexels-photo-35144341.jpeg',
    duration: '4-6 Days',
    destinations: ['Manali', 'Shimla', 'Kashmir'],
    includes: ['Luxury Hotel', 'Adventure Activities', 'Scenic Tours', 'Romantic Dinners']
  },
  {
    id: 'custom-package',
    title: 'Customized Honeymoon',
    description: 'Tailor-made honeymoon experiences designed around your preferences and dreams.',
    image: 'https://images.unsplash.com/photo-1764751281139-d74ef359409b',
    duration: 'Flexible',
    destinations: ['Worldwide'],
    includes: ['Personalized Itinerary', 'Hotel Booking', 'Activity Planning', '24/7 Support']
  }
];

export const decorServices = [
  {
    id: 'mandap',
    title: 'Mandap Décor',
    description: 'Exquisite mandap designs with traditional and contemporary elements, floral arrangements, and premium fabrics.',
    image: 'https://images.unsplash.com/photo-1605553426886-c0a99033fda0'
  },
  {
    id: 'stage',
    title: 'Stage Decoration',
    description: 'Stunning stage setups for sangeet, reception, and ceremonies with lighting, backdrops, and floral designs.',
    image: 'https://images.unsplash.com/photo-1745573673583-a51f665ae48e'
  },
  {
    id: 'floral',
    title: 'Floral Arrangements',
    description: 'Premium fresh flowers, bouquets, centerpieces, and complete venue transformation with elegant florals.',
    image: 'https://images.unsplash.com/photo-1595467959554-9ffcbf37f10f'
  },
  {
    id: 'lighting',
    title: 'Lighting & Ambiance',
    description: 'Professional lighting design including fairy lights, uplighting, spotlights, and ambient mood creation.',
    image: 'https://images.unsplash.com/photo-1752857015591-c1b85c01c461'
  },
  {
    id: 'theme',
    title: 'Theme-Based Décor',
    description: 'Customized theme décor including royal, vintage, beach, garden, and contemporary themes.',
    image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed'
  },
  {
    id: 'table',
    title: 'Table Styling',
    description: 'Elegant table settings, centerpieces, linens, cutlery arrangements, and complete dining aesthetics.',
    image: 'https://images.pexels.com/photos/931177/pexels-photo-931177.jpeg'
  }
];

export const soundEquipment = [
  {
    brand: 'JBL',
    description: 'Premium JBL sound systems for crystal-clear audio, powerful bass, and professional-grade performance.',
    features: ['Professional Grade', 'Crystal Clear Audio', 'Powerful Bass', 'Reliable Performance']
  },
  {
    brand: 'RCF',
    description: 'High-end RCF sound systems delivering exceptional sound quality for weddings and events.',
    features: ['High-End Quality', 'Exceptional Clarity', 'Large Venue Support', 'Professional Setup']
  }
];

export const entertainmentServices = [
  {
    id: 'dj',
    title: 'Professional DJ',
    description: 'Experienced DJs with latest equipment and extensive music library for all wedding events.',
    image: 'https://images.unsplash.com/photo-1698602807831-81066d89ed41'
  },
  {
    id: 'live-band',
    title: 'Live Band & Singers',
    description: 'Professional live bands and renowned singers for sangeet, wedding, and reception performances.',
    image: 'https://images.unsplash.com/photo-1642178225043-f299072af862'
  },
  {
    id: 'traditional',
    title: 'Traditional Performances',
    description: 'Dhol players, folk artists, and traditional performers to add cultural richness to celebrations.',
    image: 'https://images.unsplash.com/photo-1587012521796-6359d3678f2a'
  },
  {
    id: 'stage-production',
    title: 'Stage Lighting & Effects',
    description: 'Professional stage lighting, LED effects, fog machines, and complete production setup.',
    image: 'https://images.unsplash.com/photo-1642178233359-1c87278a80d8'
  }
];